import * as Comp from './content-subtitlte.styles'

import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'

type ContentSubtitleProps = {
  children: React.ReactNode
  testID?: string
}

export function ContentSubtitle(props: ContentSubtitleProps) {
  const { children, testID, __scopeContent } =
    props as ScopedProps<ContentSubtitleProps>

  const { ...contentProps } = useContentContext(DISPLAY_NAME, __scopeContent)

  const behaviorProps = {
    numberOfLines: 2,
    ellipsizeMode: 'tail',
  } as const

  return (
    <Comp.Subtitle {...behaviorProps} {...contentProps} testID={testID}>
      {children}
    </Comp.Subtitle>
  )
}
